import { request } from './apiClient'

export const fetchEngines = () => request("GET", "/v1/engines/")
